<!-- 播放视频 -->
<template>
  <span>
    <button :class="triggerClass" @click="play" />
    <van-popup
      v-model="visible"
      get-container="body"
      style="background-color: transparent; overflow-y: visible"
      @closed="handleClosed"
    >
      <div :class="$style.player">
        <btn-close
          style="
            z-index: 9;
            position: absolute;
            bottom: -1.2rem;
            right: 50%;
            transform: translateX(50%);
          "
          @click="visible = false"
        />
        <video v-if="src" ref="video" :src="src" controls autoplay playsinline />
      </div>
    </van-popup>
  </span>
</template>

<script>
import BtnClose from '../BtnClose'

export default {
  name: 'BtnPlayVideo',
  components: { BtnClose },
  props: {
    triggerClass: String,
    src: String
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    play() {
      this.visible = true
      if (this.$refs.video) {
        this.$refs.video.play()
      }
    },
    // 关闭时停止播放
    handleClosed() {
      this.$refs.video.pause()
      this.$refs.video.currentTime = 0
    }
  }
}
</script>

<style lang="less" module>
.player {
  position: relative;
  display: flex;
  align-items: center;
  width: 7.5rem;

  video {
    width: 100%;
  }
}
</style>
